module.exports = __webpack_public_path__ + "img/DSWTrainingPart1.1dbd12e9.jpg";